import { render, staticRenderFns } from "./ResumenBiasSms.vue?vue&type=template&id=cbe2eaa8&scoped=true&"
import script from "./ResumenBiasSms.vue?vue&type=script&lang=js&"
export * from "./ResumenBiasSms.vue?vue&type=script&lang=js&"
import style0 from "./ResumenBiasSms.vue?vue&type=style&index=0&id=cbe2eaa8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbe2eaa8",
  null
  
)

export default component.exports